import "@perxis-auto/shared";
import "react";
import "../../api/api.js";
import "../../model/middleware/index.js";
import "../../model/selectors/selectAllFilterValues.js";
import "../../model/selectors/selectAllFilterValuesParameters.js";
import "../../model/selectors/selectAvailableFilterValues.js";
import "../../model/selectors/selectAvailableFilterValuesParameters.js";
import "../../model/selectors/selectAvailableFilterValuesQueries.js";
import "../../model/selectors/selectDependentFilterKeysByKey.js";
import "../../model/selectors/selectFilterImmutableQueries.js";
import "../../model/selectors/selectFilterImmutableValues.js";
import "../../model/selectors/selectFilterItemByKey.js";
import "../../model/selectors/selectFilterItems.js";
import "../../model/selectors/selectFilterValuesFields.js";
import "../../model/selectors/selectGroupedFilterItemByKey.js";
import "../../model/selectors/selectIsFilterValuesMissing.js";
import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import "../../../../shared/config/env.js";
import "../../../../shared/config/events.js";
import "react-router";
import "../../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../../shared/store/config/model/selectors/selectModels.js";
import "../../../../shared/store/config/model/selectors/selectSort.js";
import "../../../../shared/store/config/model/selectors/selectTags.js";
import "../../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../../shared/store/config/model/slice.js";
import "../../../../shared/store/installation/model/slice.js";
import "../../../../shared/store/pagination/model/slice.js";
import "../../../filterChoice/model/middleware/index.js";
import "../../../filterChoice/model/selectors/selectFilterHistory.js";
import "../../../filterChoice/model/selectors/selectFilterSortValue.js";
import "../../../filterChoice/model/selectors/selectFilterValuesCount.js";
import { selectIsFilterValuesSelected } from "../../../filterChoice/model/selectors/selectIsFilterValuesSelected.js";
import "../../../filterChoice/model/selectors/selectIsInitialSortValuesSelected.js";
import "../../../filterChoice/model/selectors/selectIsValidSortValuesSelected.js";
import "../../../filterChoice/model/selectors/selectSlugedFilterValues.js";
import "../../../filterChoice/model/slice.js";
import "history";
import { PerxisService } from "../../../../shared/services/perxis/index.js";
import { getExtendedItems } from "../../../../shared/store/reference/lib/getExtendedItems.js";
import "../../../../shared/store/reference/model/index.js";
import "@perxis-auto/shared/lib/lib/instanceOf";
import { createRawFilterValuesItem } from "./create/createRawFilterValuesItem.js";
import { formatExtRawFilterValuesItem } from "./format/formatExtRawFilterValuesItem.js";
import { formatFilterValuesParameters } from "./format/formatFilterValuesParameters.js";
import { fetchFilterValuesWithExtraValues } from "./fetchFilterValuesWithExtraValues.js";
const fetchAvailableFilterValues = async (queryApi, parameters, allRawFilterValuesItem) => {
  var _a;
  const state = queryApi.getState();
  const queries = [];
  const immutableQueries = [];
  (((_a = parameters.filter) == null ? void 0 : _a.q) || []).forEach((query) => {
    var _a2;
    const isImmutableQuery = (((_a2 = allRawFilterValuesItem.parameters.filter) == null ? void 0 : _a2.q) || []).includes(query);
    if (isImmutableQuery) {
      immutableQueries.push(query);
    } else {
      queries.push(query);
    }
  });
  const isFilterValuesSelected = selectIsFilterValuesSelected(state);
  const isFilterQueriesExisted = !!queries.length;
  if (!isFilterQueriesExisted || !isFilterValuesSelected) {
    return allRawFilterValuesItem;
  }
  const { itemsClient } = PerxisService.getInstance();
  const { result: data = {} } = await itemsClient.aggregatePublished(formatFilterValuesParameters(parameters));
  const availableRawFilterValuesItem = createRawFilterValuesItem(data, parameters);
  const [extAvailableRawFilterValuesItem] = await getExtendedItems(
    queryApi,
    [availableRawFilterValuesItem]
  );
  const formattedExtAvailableRawFilterValuesItem = formatExtRawFilterValuesItem(extAvailableRawFilterValuesItem);
  if (!queries.length) {
    return formattedExtAvailableRawFilterValuesItem;
  }
  const promises = [];
  const allRawFilterValuesData = allRawFilterValuesItem.data;
  const filterKeys = Object.keys(allRawFilterValuesData);
  for (const filterKey of filterKeys) {
    const filterIndex = queries.findIndex((query) => {
      var _a2, _b;
      const isFieldFound = ((_b = (_a2 = parameters.filter) == null ? void 0 : _a2.qMap) == null ? void 0 : _b[filterKey]) === query;
      return isFieldFound;
    }) ?? -1;
    if (filterIndex < 0) {
      continue;
    }
    const queriesWithoutSomeQuery = (queries == null ? void 0 : queries.filter((_, index) => index !== filterIndex)) || [];
    if (!queriesWithoutSomeQuery.length) {
      const promise = Promise.resolve({
        [filterKey]: allRawFilterValuesData == null ? void 0 : allRawFilterValuesData[filterKey]
      });
      promises.push(promise);
    } else {
      const { filter, ...baseParameters } = parameters;
      const parametersForSomeFilter = formatFilterValuesParameters({
        ...baseParameters,
        filter: {
          ...filter,
          q: [...immutableQueries, ...queriesWithoutSomeQuery]
        }
      });
      const promise = itemsClient.aggregatePublished(parametersForSomeFilter).then(({ result = {} }) => {
        const rawFilterValuesForSomeFilterItem = createRawFilterValuesItem(result, parametersForSomeFilter);
        return getExtendedItems(queryApi, [
          rawFilterValuesForSomeFilterItem
        ]);
      }).then(([extRawFilterValuesForSomeFilterItem]) => {
        var _a2;
        return {
          // Возможные значения фильтра, которые был исключены из фильтрации
          [filterKey]: (_a2 = extRawFilterValuesForSomeFilterItem.data) == null ? void 0 : _a2[filterKey]
        };
      });
      promises.push(promise);
    }
  }
  const results = await Promise.all(promises);
  Object.assign(formattedExtAvailableRawFilterValuesItem.data, ...results);
  const extAvailableRawFilterValuesWithValuesItem = await fetchFilterValuesWithExtraValues(
    queryApi,
    formattedExtAvailableRawFilterValuesItem
  );
  return extAvailableRawFilterValuesWithValuesItem;
};
export {
  fetchAvailableFilterValues
};
